import { render } from "./PredictionAccuracyWidget.vue?vue&type=template&id=a4b54aaa&scoped=true"
import script from "./PredictionAccuracyWidget.vue?vue&type=script&lang=js"
export * from "./PredictionAccuracyWidget.vue?vue&type=script&lang=js"

import "./PredictionAccuracyWidget.vue?vue&type=style&index=0&id=a4b54aaa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4b54aaa"]])

export default __exports__